///////COMPONENTS///////
import initialState from '../initialState'
import login from './login'
import languages from './languages'
import usersManager from './usersManager'
import errorManager from './errorManager'
import globalLoading from './globalLoading'
import modals from './modals'
import rolesManager from './rolesManager'
import tagsManager from './tagsManager'
import toastSuccess from './toastSucess'
import myAccount from './account'
import kioskPerimeter from './kioskPerimeter'
import datePicker from './datePicker'
import recapStock from '../reducers/recapStock'
import salesHistoryManager from './salesHistoryManager'
import scheduledPricesManager from './scheduledPricesManager'
import scheduledPromoManager from './scheduledPromoManager'
import pricesManagerByArticle from './pricesManagerByArticle'
import consignation from './consignation'
import kioskPricesManager from './kioskPricesManager'
import logExtranet from './logExtranet'
import logKiosk from './logKiosk'
import logSynchro from './logSynchro'
import logUsers from './logUsers'
import campaignPrice from './campaignPrice'
import campaignPromo from './campaignPromo'
import rgpd from './rgpd'
import telecollectManager from './telecollectManager'
import salesByArticleHistoryManager from './salesByArticleHistoryManager'
import salesHistoryByCodes from './salesHistoryByCodes'
import distributionGroupRepository from './distributionGroupRepository'
import articleManager from './articleManager'
import addItemCatalog from './addItemCatalog'
import companiesManager from './companiesManager'
import translationsManager from './translationsManager'
import exportDatas from './exportDatas'
import userPreferences from './userPreferences'
import notifications from './notifications'
import articleLifeManager from './articleLifeManager'
import headerCarousel from './headerCarousel'
import initKioskManager from './initKioskManager'
import initKioskCreationDefinition from './initKioskCreationDefinition'
import initKioskCreationBankDetails from './initKioskCreationBankDetails'
import initKioskCreationAddItems from './initKioskCreationAddItems'
import initKioskCreationAddPrices from './initKioskCreationAddPrices'
import initKioskImplantation from './initKioskCreationImplantation'
import initKioskCreationSummary from './initKioskCreationSummary'
import marketing from './marketing'
import kioskProductionList from './kioskProductionList'
import kioskDiagnostic from './kioskDiagnostic'
import itemCatalogDetail from './itemCatalogDetail'
import itemCatalog from './itemCatalog'
import columns from './columns'
import kioskEditSetup from './kioskEditSetup'
import kioskRacksRequest from './kioskRacksRequest'
import kioskEditImplantation from './kioskEditImplantation'
import languagesManager from './languagesManager'
import table from './table'
import salesControl from './salesControl'

const reducersMap = {
	...login,
	...languages,
	...usersManager,
	...errorManager,
	...globalLoading,
	...modals,
	...rolesManager,
	...tagsManager,
	...toastSuccess,
	...myAccount,
	...kioskPerimeter,
	...datePicker,
	...recapStock,
	...salesHistoryManager,
	...scheduledPricesManager,
	...scheduledPromoManager,
	...pricesManagerByArticle,
	...consignation,
	...kioskPricesManager,
	...logExtranet,
	...logKiosk,
	...logSynchro,
	...logUsers,
	...campaignPrice,
	...campaignPromo,
	...rgpd,
	...telecollectManager,
	...salesHistoryByCodes,
	...salesByArticleHistoryManager,
	...distributionGroupRepository,
	...articleManager,
	...addItemCatalog,
	...companiesManager,
	...exportDatas,
	...translationsManager,
	...userPreferences,
	...notifications,
	...articleLifeManager,
	...headerCarousel,
	...initKioskManager,
	...initKioskCreationDefinition,
	...initKioskCreationBankDetails,
	...initKioskCreationAddItems,
	...initKioskCreationAddPrices,
	...initKioskImplantation,
	...initKioskCreationSummary,
	...marketing,
	...kioskProductionList,
	...kioskDiagnostic,
	...itemCatalogDetail,
	...itemCatalog,
	...columns,
	...kioskEditSetup,
	...kioskRacksRequest,
	...kioskEditImplantation,
	...languagesManager,
	...table,
	...salesControl,
	leaveStateUnchanged: (state) => state,
}

const reducers = function reducers(state = initialState, action) {
	const reducer = reducersMap[action.type] || reducersMap.leaveStateUnchanged
	return reducer(state, action.payload, action.meta)
}

export default reducers
